import skill1 from "./Python-Emblem.jpg"
import skill2 from "./ISO_C++_Logo.svg.png"
import skill3 from "./1200px-C_Programming_Language.svg.png"
import skill4 from "./Blog-Article-MERN-Stack.jpg"


export default [
    {
        id:1,
        img:skill1,
        title:"Python"
    },
    {
        id:2,
        img:skill2,
        title:"C++"
    },
    {
        id:3,
        img:skill3,
        title:"C"
    },
    {
        id:4,
        img:skill4,
        title:"Full Stack Web Development"
    },
]